import { Text, TextProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

const WrappedText: React.FC<TextProps> = forwardRef<HTMLParagraphElement, TextProps>(
  ({ children, ...props }, ref) => {
    return (
      <Text {...props} ref={ref} sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
        {children}
      </Text>
    );
  }
);

export default WrappedText;
